import { render, staticRenderFns } from "./LessonReview.vue?vue&type=template&id=05a15653&"
import script from "./LessonReview.vue?vue&type=script&lang=js&"
export * from "./LessonReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports